import React from 'react';
import { TextFieldProps } from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';
import { BaseTextField } from './BaseTextField';
import { GetCurrencyFormatter } from '../Formatters';

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberFormatCustom = (props: NumberFormatCustomProps) => {
  const { inputRef, onChange, name, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
};

interface CurrencyTextFieldProps {
  currency: string;
}

export const CurrencyTextField: React.FC<CurrencyTextFieldProps &
  TextFieldProps> = ({ onChange, currency, ...textFieldProps }) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (onChange) {
      onChange(event);
    }
  };
  const formatter = GetCurrencyFormatter(currency);
  const formatterOptions = formatter.formatToParts();
  const prefix =
    formatterOptions.find(opt => opt.type === 'currency')?.value || '$';

  const textFieldInputProps = {
    InputProps: {
      inputComponent: NumberFormatCustom as any, // casting as any so that mui TextField doesn't complain
    },
    inputProps: {
      prefix,
    },
  };
  return (
    <BaseTextField
      {...textFieldProps}
      {...textFieldInputProps}
      onChange={handleChange}
    />
  );
};
